import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, FlagIcon, UsersIcon, LeafIcon } from 'lucide-react';
const pillars = [{
  icon: GlobeIcon,
  title: 'Better for the Planet',
  description: 'Less plastic. Less waste. More green.'
}, {
  icon: FlagIcon,
  title: 'Better for the Game',
  description: 'Protect the courses we care about.'
}, {
  icon: UsersIcon,
  title: 'Better for Everyone',
  description: 'Small actions. Stronger community.'
}, {
  icon: LeafIcon,
  title: 'Better for Tomorrow',
  description: 'A cleaner today. A brighter future.'
}];
export function Mission() {
  return <section id="mission" className="py-24 md:py-32 px-4 bg-cream" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-135">
          <div className="text-xs uppercase tracking-[0.25em] text-green font-medium mb-4" data-id="element-136">
            Our mission
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-bold text-charcoal mb-6 leading-tight" data-id="element-137">
            Small Change.
            <br data-id="element-138" />
            Lasting Legacy.
          </h2>
          <p className="text-lg text-charcoal/70 leading-relaxed" data-id="element-139">
            Every Birdie Bag helps cut down plastic waste and build a cleaner
            future for the game we love. We don't just play the game — we
            protect it.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-140">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-5 items-start" data-id="element-141">
              <div className="w-12 h-12 rounded-full bg-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-142">
                <pillar.icon className="w-5 h-5 text-green" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <h3 className="font-display text-xl font-bold text-charcoal mb-1" data-id="element-145">
                  {pillar.title}
                </h3>
                <p className="text-charcoal/70 leading-relaxed" data-id="element-146">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-20 pt-12 border-t border-stone max-w-xl mx-auto" data-id="element-147">
          <p className="font-display text-2xl md:text-3xl text-charcoal italic" data-id="element-148">
            "Birdie Better."
          </p>
          <p className="text-sm text-charcoal/60 mt-3 tracking-wide" data-id="element-149">
            Thanks for making every choice count.
          </p>
        </motion.div>
      </div>
    </section>;
}